import { render, staticRenderFns } from "./DevisTypesBAREN.vue?vue&type=template&id=0f7741c4&scoped=true"
import script from "./DevisTypesBAREN.vue?vue&type=script&lang=js"
export * from "./DevisTypesBAREN.vue?vue&type=script&lang=js"
import style0 from "./DevisTypesBAREN.vue?vue&type=style&index=0&id=0f7741c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7741c4",
  null
  
)

export default component.exports